import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from '~/utils/helpers';

interface ISkeletonInputBlock {
  titleWidth: number;
  blockWidth: number;
}

interface ISkeletonRadiosBlock {
  titleWidth: number;
  optionsCount: number;
}

const SkeletonInputBlock: FC<ISkeletonInputBlock> = ({ titleWidth, blockWidth }: ISkeletonInputBlock): ReactElement => {
  return (
    <div className="d-flex flex-column gap-10">
      <Skeleton width={titleWidth} height={22} />
      <Skeleton width={blockWidth} height={46} style={{ borderRadius: 12 }} />
    </div>
  );
};

const SkeletonRadiosBlock: FC<ISkeletonRadiosBlock> = ({ titleWidth, optionsCount }: ISkeletonRadiosBlock): ReactElement => {
  return (
    <div className="d-flex flex-column gap-20">
      <Skeleton width={titleWidth} height={22} />
      <div className="d-flex flex-row flex-wrap gap-20">
        {emptyArray(optionsCount).map((_, index) => (
          <Skeleton key={index} width={78} height={24} style={{ borderRadius: 12 }} />
        ))}
      </div>
    </div>
  );
};

export const PreparationSettingMainSkeletons: FC = (): ReactElement => {
  return (
    <>
      <div className="d-flex flex-column gap-30">
        {/* delivery */}
        <div className="d-flex flex-column gap-20">
          <Skeleton width={350} height={22} />

          <div className="d-flex flex-column gap-25">
            <SkeletonRadiosBlock titleWidth={120} optionsCount={3} />
            <SkeletonInputBlock titleWidth={120} blockWidth={345} />
            <SkeletonInputBlock titleWidth={245} blockWidth={345} />
          </div>
        </div>

        {/* pickup */}
        <div className="d-flex flex-column gap-20">
          <Skeleton width={340} height={22} />

          <div className="d-flex flex-column gap-25">
            <SkeletonRadiosBlock titleWidth={120} optionsCount={3} />
            <SkeletonInputBlock titleWidth={120} blockWidth={345} />
            <SkeletonInputBlock titleWidth={245} blockWidth={345} />
          </div>
        </div>

        {/* preOrder */}
        <div className="d-flex flex-column gap-20">
          <Skeleton width={270} height={22} />

          <div className="d-flex flex-column gap-25">
            <SkeletonRadiosBlock titleWidth={130} optionsCount={4} />
            <SkeletonInputBlock titleWidth={245} blockWidth={345} />
            <SkeletonInputBlock titleWidth={150} blockWidth={440} />
          </div>
        </div>
      </div>

      <Skeleton width={140} height={46} style={{ borderRadius: 12 }} />
    </>
  );
};
